import React from 'react';
import { AlertTriangle, RefreshCcw, ChevronDown } from 'lucide-react';

interface ErrorFallbackProps {
  error: Error;
  componentStack?: string;
  resetError?: () => void;
  className?: string;
}

export function ErrorFallback({ error, componentStack, resetError, className = '' }: ErrorFallbackProps) {
  const [showDetails, setShowDetails] = React.useState(false);

  return (
    <div className={`p-4 bg-red-950/50 backdrop-blur-lg rounded-lg border border-red-500/20 ${className}`}>
      <div className="flex items-start gap-3">
        <AlertTriangle className="text-red-400 mt-1" size={20} />
        <div className="flex-1 min-w-0">
          <h2 className="font-medium text-red-200">Something went wrong</h2>
          <p className="mt-1 text-red-300/90 text-sm">
            {error.message || 'An unexpected error occurred'}
          </p>
          
          {componentStack && (
            <button
              onClick={() => setShowDetails(!showDetails)}
              className="mt-2 flex items-center gap-1 text-xs text-red-400 hover:text-red-300"
            >
              <ChevronDown
                size={14}
                className={`transform transition-transform ${showDetails ? 'rotate-180' : ''}`}
              />
              {showDetails ? 'Hide' : 'Show'} technical details
            </button>
          )}

          {showDetails && componentStack && (
            <pre className="mt-2 p-2 bg-red-950/30 rounded border border-red-500/10 text-red-300/70 text-xs overflow-x-auto">
              {componentStack}
            </pre>
          )}

          {resetError && (
            <button
              onClick={resetError}
              className="mt-3 flex items-center gap-2 px-3 py-1.5 bg-red-500/10 hover:bg-red-500/20 
                text-red-300 text-sm rounded-md transition-colors"
            >
              <RefreshCcw size={14} />
              Try again
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
